var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"background",attrs:{"src":require("@/assets/background-login.webp")}})
}
var staticRenderFns = []

export { render, staticRenderFns }